import {openResourceModal} from '../../core/modalCommand';
import {reportActiveAgentModalLifecycle} from '../../core/modalLifecycle';
import {
	FIRMWARE_ADD_AP_IMAGE_MODAL_EVENT,
	FIRMWARE_ADD_AP_TASK_MODAL_EVENT,
	FIRMWARE_ADD_SWITCH_IMAGE_MODAL_EVENT,
	FIRMWARE_LIST_EVENTS,
} from './events';

/**
 * Build an opener that hands the command to one event.
 * @param {string} eventName event the owning component listens for
 * @return {Function} modal handler
 */
function opener(eventName) {
	return (command, envelope) => openResourceModal(eventName, command, envelope);
}

export const openAddApFirmwareModal = opener(FIRMWARE_ADD_AP_IMAGE_MODAL_EVENT);
export const openAddApFirmwareTaskModal = opener(FIRMWARE_ADD_AP_TASK_MODAL_EVENT);
export const openAddSwitchFirmwareModal =
	opener(FIRMWARE_ADD_SWITCH_IMAGE_MODAL_EVENT);
export const openUpgradeApFirmwareModal =
	opener(FIRMWARE_LIST_EVENTS.ap_firmware.upgrade);
export const openDeleteApFirmwareModal =
	opener(FIRMWARE_LIST_EVENTS.ap_firmware.delete);
export const openEditApFirmwareTaskModal =
	opener(FIRMWARE_LIST_EVENTS.ap_firmware_task.edit);
export const openDeleteApFirmwareTaskModal =
	opener(FIRMWARE_LIST_EVENTS.ap_firmware_task.delete);
export const openUpgradeSwitchFirmwareModal =
	opener(FIRMWARE_LIST_EVENTS.switch_firmware.upgrade);
export const openDeleteSwitchFirmwareModal =
	opener(FIRMWARE_LIST_EVENTS.switch_firmware.delete);

/**
 * Report a Firmware Management modal outcome.
 *
 * Safe to call from any close or save path: it does nothing when no agent
 * command opened the form, so a form the person opened themselves reports
 * nothing and is untouched.
 *
 * @param {'modal.cancelled'|'modal.saved'|'modal.failed'} eventType lifecycle event
 * @param {string|null} [errorCode] failure reason when the save did not complete
 * @return {Promise<object|null>} agent response
 */
export function reportFirmwareModalLifecycle(eventType, errorCode = null) {
	return reportActiveAgentModalLifecycle(eventType, errorCode);
}
